import { createAsyncThunk } from "@reduxjs/toolkit";
import { persistor } from "store";
import { appActions } from "store/app/app.slice";
import { currentUserActions } from "store/current-user/current-user.slice";

export const logout = createAsyncThunk(
  "currentUser/logout",
  async (undefined, { dispatch, getState }) => {
    dispatch(appActions.setLogoutConfirmationMenu({ isOpen: false }));
    dispatch(appActions.setEditUserUserNameMenu({ isOpen: false }));
    dispatch(appActions.setEditUserPasswordMenu({ isOpen: false }));
    dispatch(currentUserActions.setAuth(null));
    dispatch(currentUserActions.setUser(null));
    await persistor.flush();
    window.location.pathname = "/";
  }
);
